const Settings =  {
    app_version: '1.4.5',
    push_time: '24.08.2026, 11:55'
}
export default Settings
